import {Component} from '@angular/core';

@Component({
    selector: 'app-code-inline',
    templateUrl: 'code-inline.component.html',
    styleUrls: ['code-inline.component.scss'],
})
export class CodeInlineComponent {
}
